<template>
    <v-card
        class="h-full"
    >
        <v-card-text
            class="d-flex flex-column h-full pa-0"
            :class="checking ? 'justify-center' : ''"
        >
            <template
                v-if="!checking"
            >
                <legacy-title
                    class="pa-4 mt-3 title-branding"
                    border
                >
                    KeyPlan in Action
                </legacy-title>

                <template
                    v-if="!client.product"
                >
                    <p
                        class="px-4"
                    >
                        Select a plan to see your benefits
                    </p>
                </template>

                <template
                    v-else
                >
                    <attributes/>
                </template>
            </template>
            <template
                v-else
            >
                <div
                    class="text-center"
                >
                    <v-progress-circular
                        :color="$vuetify.theme.dark ? 'secondary' : 'primary'"
                        :size="50"
                        indeterminate
                    ></v-progress-circular>
                </div>
            </template>
        </v-card-text>
    </v-card>
</template>

<script>
    import LegacyTitle from './../../Global/Title';
    import Attributes from './Attributes';

    import KeyPlanMixin from "./../keyplan";

    export default {
        name: 'Key-Plan-Side-Menu',

        mixins: [
            KeyPlanMixin
        ],

        components: {
            LegacyTitle,
            Attributes
        },

        data() {
            return {}
        },
    }
</script>
